"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultDashboardKpiWidget = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importDefault(require("react"));
var presentationComponents_1 = require("../../presentationComponents");
var kpi_1 = require("../kpi");
var model_1 = require("../../../model");
exports.DefaultDashboardKpiWidget = function (props) {
    var kpiWidget = props.kpiWidget, onError = props.onError, onFiltersChange = props.onFiltersChange, screen = props.screen, dashboardItemClasses = props.dashboardItemClasses;
    var isSelected = model_1.useWidgetSelection(sdk_model_1.widgetRef(kpiWidget)).isSelected;
    var alertSelector = model_1.selectAlertByWidgetRef(sdk_model_1.widgetRef(kpiWidget));
    var alert = model_1.useDashboardSelector(alertSelector);
    return (react_1.default.createElement(presentationComponents_1.DashboardItem, { className: classnames_1.default("type-kpi", dashboardItemClasses, { "is-selected": isSelected }), screen: screen },
        react_1.default.createElement(kpi_1.DashboardKpi, { kpiWidget: kpiWidget, alert: alert, onFiltersChange: onFiltersChange, onError: onError })));
};
//# sourceMappingURL=DefaultDashboardKpiWidget.js.map